// A location-limited read-only session stays in this iframe's memory, never owner storage.
export const isAdminView = window.parent !== window;
let token=null;
export function viewToken(){return token;}
export function clearView(){token=null;}
export function waitForAdminView(){
 if(!isAdminView)return Promise.resolve();
 const origin=import.meta.env.VITE_ADMIN_ORIGIN || 'https://hireaigo.com';
 const nonce=crypto.randomUUID();
 return new Promise((resolve,reject)=>{
  const ready=()=>window.parent.postMessage({type:'aigo-owner-ready',nonce},origin);
  const finish=()=>{clearTimeout(timeout);clearInterval(interval);window.removeEventListener('message',receive);};
  const receive=e=>{if(e.source!==window.parent||e.origin!==origin||e.data?.type!=='aigo-owner-view'||e.data?.nonce!==nonce)return;if(!/^av_[a-f0-9]{64}$/.test(e.data.token||''))return;token=e.data.token;finish();resolve();};
  window.addEventListener('message',receive);
  const interval=setInterval(ready,1000),timeout=setTimeout(()=>{finish();reject(Error('Owner view could not connect. Reopen it from the location in admin.'));},25000);
  ready();
 });
}
